import type { ReactNode } from 'react';
import React, { Children } from 'react';
import { getCols } from 'Components/utils/layout/layout.utils';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  children: ReactNode;
  className?: string;
  colsNumber?: number;
};
export const Columns = ({ children, className, colsNumber = 2 }: Props) => {
  const childrenArray = Children.toArray(children);
  const l = childrenArray.filter(Boolean).length;

  if (!l) {
    return null;
  }

  if (colsNumber === 1) {
    return children;
  }

  const cols = getCols(colsNumber, childrenArray);
  return (
    <div className={classnames('-mx-10 flex flex-wrap', className)}>
      {cols.map((col, i) => (
        <div className={`px-10 w-1/${colsNumber}`} key={i}>
          {col}
        </div>
      ))}
    </div>
  );
};
